import { useCallback, useState } from 'react';

import { COPY_TIMEOUT_MS } from '../../constants';

/**
 * Returns { copied, copy } where copy(text) writes to the clipboard
 * and flips `copied` to true for `timeout` ms.
 */
export function useCopyToClipboard(timeout = COPY_TIMEOUT_MS): {
  copied: boolean;
  copy: (text: string) => void;
} {
  const [copied, setCopied] = useState(false);

  const copy = useCallback(
    (text: string) => {
      void navigator.clipboard.writeText(text).then(() => {
        setCopied(true);
        setTimeout(() => setCopied(false), timeout);
      });
    },
    [timeout],
  );

  return { copied, copy };
}
